import {create} from 'zustand'
import {createToastSlice, IToastStore} from './toast/toastStore'
import {createHomeSlice, IHomeStore} from './home/homeStore'
import {
  createTaskHuddleSlice,
  ITaskHuddleStore,
} from './taskHuddle/taskHuddleStore'
import {createIdeationSlice, IIdeationStore} from './ideation/ideationStore'
import {
  createAnalyticsTeamViewSlice,
  IAnalyticsTeamViewStore,
} from './analyticsTeamView/analyticsTeamViewStore'
import {
  createInitiativesSlice,
  IInitiativesStore,
} from './initiatives/initiativesStore'
import {createUserSlice, IUserStore} from './user/userStore'

export const useAppStore = create<
  IToastStore &
    IHomeStore &
    ITaskHuddleStore &
    IIdeationStore &
    IAnalyticsTeamViewStore &
    IInitiativesStore &
    IUserStore
>()((...a) => ({
  ...createToastSlice(...a),
  ...createHomeSlice(...a),
  ...createTaskHuddleSlice(...a),
  ...createIdeationSlice(...a),
  ...createAnalyticsTeamViewSlice(...a),
  ...createInitiativesSlice(...a),
  ...createUserSlice(...a),
}))
